// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__GXX6M","collapsibleIcon":"styles_collapsibleIcon__QrxZc"};